import $ from 'jquery';
import toastr from 'toastr';
import { storeInSession, scopeWithKey } from 'utils/storage';

const FLASH_SUCCESS_STORAGE_KEY = 'capmobil@@flash-success';

export default () => {
  const notification = $('#notifications').html().trim();
  if (notification && notification.length) {
    success(notification);
  }

  const errorNotification = $('#error-notifications').html().trim();
  if (errorNotification && errorNotification.length) {
    error(errorNotification);
  }

  // Bind from session storage flash
  scopeWithKey(FLASH_SUCCESS_STORAGE_KEY, value => success(value));
};

export function storeSuccess(content) {
  storeInSession(FLASH_SUCCESS_STORAGE_KEY, content);
}

export function success(content) {
  toastr.success(content);
}

export function error(content) {
  toastr.error(content);
}



// WEBPACK FOOTER //
// ./src/plugins/toastr.js